import { cn } from "@/lib/utils";
import { EmptyState, Loading } from "./Primitives";
import { Inbox } from "lucide-react";

export function DataTable({ columns, rows, loading, onRowClick, keyField = "id",
  testIdPrefix = "row", empty }) {
  if (loading) return <Loading />;
  if (!rows || rows.length === 0)
    return empty || <EmptyState icon={Inbox} title="Keine Einträge" description="Es wurden keine Daten gefunden." />;

  return (
    <div className="overflow-hidden rounded-lg border border-border bg-card shadow-sm">
      {/* Desktop table */}
      <div className="hidden overflow-x-auto sm:block">
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="border-b border-border bg-muted/40">
              {columns.map((c) => (
                <th key={c.key} className={cn("whitespace-nowrap px-4 py-2.5 text-xs font-semibold uppercase tracking-wider text-muted-foreground", c.headClass)}>
                  {c.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r[keyField]} onClick={onRowClick ? () => onRowClick(r) : undefined}
                data-testid={`${testIdPrefix}-${r[keyField]}`}
                className={cn("border-b border-border/60 transition-colors last:border-0 hover:bg-muted/40",
                  onRowClick && "cursor-pointer")}>
                {columns.map((c) => (
                  <td key={c.key} className={cn("px-4 py-3 align-middle", c.cellClass)}>
                    {c.render ? c.render(r) : r[c.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="divide-y divide-border sm:hidden">
        {rows.map((r) => (
          <div key={r[keyField]} onClick={onRowClick ? () => onRowClick(r) : undefined}
            data-testid={`${testIdPrefix}-mobile-${r[keyField]}`}
            className={cn("space-y-1.5 px-4 py-3", onRowClick && "cursor-pointer active:bg-muted/40")}>
            {columns.filter((c) => !c.mobileHidden).map((c) => (
              <div key={c.key} className="flex items-start justify-between gap-3">
                <span className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">{c.header}</span>
                <span className="min-w-0 text-right text-sm">{c.render ? c.render(r) : r[c.key]}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
